const siteConfig = {
  brandName: "ierryhouse",
  brandTagline: "Tools for thoughtful work",
  description:
    "Thoughtfully selected stationery for writing, drawing, planning, and everyday creative work.",
  announcement:
    "Carefully packed from Hong Kong · Tracked delivery is $9.99.",
  currency: "USD",
  locale: "en-US",
  freeShippingThreshold: null,
  flatShippingRate: 9.99,
  logo: {
    type: "brandmark",
    text: "ierryhouse",
    ariaLabel: "ierryhouse home",
  },
  contact: {
    email: "advice@ierryhouse.shop",
    supportEmail: "advice@ierryhouse.shop",
    responseTime: "within two business days",
    address: "Hong Kong",
  },
  navigation: [
    {
      label: "PENS",
      category: "Pens",
      children: [
        "Gel Pens",
        "Ballpoint Pens",
        "Fountain Pens",
        "Brush Pens",
        "Highlighters",
        { label: "Inks & Refills", to: "/shop?q=refill" },
      ],
    },
    {
      label: "PENCILS",
      category: "Pencils",
      children: [
        "Mechanical Pencils",
        { label: "Lead Refills", to: "/shop?q=refill" },
        "Wood Pencils",
        "Lead & Erasers",
      ],
    },
    {
      label: "PAPER",
      category: "Paper",
      children: ["Letter Sets", "Notebooks", "Planners", "Sketchbooks"],
    },
    {
      label: "SHOP MORE",
      category: "More",
      children: [
        "Tape & Stickers",
        "Cases & Bags",
        { label: "Stamps & Ink Pads", to: "/shop?q=ink" },
        { label: "Erasers & Correction", to: "/shop?q=eraser" },
        { label: "Glue & Adhesives", to: "/shop?q=tape" },
        { label: "Scissors & Cutters", to: "/shop?q=scissors" },
        "Desk Tools",
        "Art Supplies",
      ],
    },
    {
      label: "MORE",
      category: "Information",
      children: [
        { label: "About Us", to: "/about" },
        { label: "FAQs", to: "/faqs" },
        { label: "Shipping Information", to: "/shipping" },
        { label: "Return Policy", to: "/returns" },
        { label: "Privacy Policy", to: "/privacy" },
        { label: "Cookie Policy", to: "/cookies" },
        { label: "Terms of Service", to: "/terms" },
        { label: "All Store Policies", to: "/policies" },
      ],
    },
  ],
  social: [],
  footerLinks: [
    { label: "About ierryhouse", to: "/about" },
    { label: "Contact Us", to: "/contact" },
    { label: "Shipping Information", to: "/shipping" },
    { label: "Returns & Refunds", to: "/returns" },
    { label: "Payment Policy", to: "/payments" },
    { label: "Order & Cancellation Policy", to: "/orders" },
    { label: "Warranty Policy", to: "/warranty" },
    { label: "Product Safety & Recalls", to: "/product-safety" },
    { label: "Promotions Policy", to: "/promotions" },
    { label: "Privacy Policy", to: "/privacy" },
    { label: "Cookie Policy", to: "/cookies" },
    { label: "Terms of Service", to: "/terms" },
    { label: "Acceptable Use", to: "/acceptable-use" },
    { label: "Intellectual Property", to: "/intellectual-property" },
    { label: "Accessibility", to: "/accessibility" },
    { label: "Complaints", to: "/complaints" },
    { label: "Legal Notice", to: "/legal" },
    { label: "All Policies", to: "/policies" },
    { label: "FAQs", to: "/faqs" },
    { label: "Blog", to: "/#journal" },
  ],
  footerPayments: [
    "AMEX",
    "Apple Pay",
    "Discover",
    "Google Pay",
    "Mastercard",
    "PayPal",
    "VISA",
  ],
  checkout: {
    supportedCards: ["VISA", "MC", "AMEX"],
    secureMessage: "Your payment is completed securely on our payment partner’s page.",
  },
};

export const formatCurrency = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
  }).format(Number(value));

export default siteConfig;
